import AjaxPageConfig from "./AjaxPageConfig";
import AjaxPage from "./AjaxPage";


export default class AjaxPageLink {
	private element: HTMLAnchorElement;
	private getConfig: () => AjaxPageConfig;

	public constructor(element: HTMLAnchorElement, getConfig: () => AjaxPageConfig) {
		this.element = element;
		this.getConfig = getConfig;

		this.onClick = this.onClick.bind(this);
		this.element.addEventListener("click", this.onClick);
	}

	private onClick(ev: MouseEvent) {
		if (ev.ctrlKey === true) {
			return; // Don't open with AJAX if user control clicked (opening in a new tab).
		}
		ev.preventDefault();

		const linkConfig = this.getConfig();

		const href = this.element.href;
		const ajaxPage = AjaxPage.getInstance(href, linkConfig);
		ajaxPage.show();
	}
	
}